/**
 * Closes the web view and returns the user to the native app via the `/close`
 * contract that the FMA shell intercepts. Skips `App.exitApp()` — calling it
 * from a sub-WebView corrupts the parent FieldPro bridge and blocks repeat
 * `openWebUrl` calls
 */
export function navigateToClose(): void {
    window.location.href = '/close';
}
